import { call, put, takeLatest } from 'redux-saga/effects';
import HeroPillsAPI from 'api-services/HeroPillsApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { checkUserHelper } from '../utils/helperSagas';
import { GET_D2D_PILLS } from './actionTypes';
import { getDayToDayPillsDone, getDayToDayPillsError } from './actionCreators';
import { logout } from '../auth/actionCreators';
export function* getDayToDayPills(constAccessParams) {
    // Check public API access token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroPillsAPI.getDayToDayPills, newAccessParams);
    if (isSuccessResponse(result)) {
        yield put(getDayToDayPillsDone(Object.assign(Object.assign({}, result.data), { config: Object.assign(Object.assign({}, result.data.config), { pills: result.data.config.pills &&
                    result.data.config.pills.map((pill) => (Object.assign(Object.assign({}, pill), { schedules: pill.schedules
                            ? pill.schedules.map((schedule) => (Object.assign(Object.assign({}, schedule), { 
                                // be won't provide this
                                id: Math.random().toString().slice(2) })))
                            : undefined }))) }) })));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(getDayToDayPillsError(result.msg));
    }
}
export function* watchGetDayToDayPills(constAccessParams) {
    yield takeLatest(GET_D2D_PILLS, getDayToDayPills, constAccessParams);
}
//# sourceMappingURL=saga.js.map